import {timer as observableTimer, from as observableFrom, Observable, Subscription} from 'rxjs';
import {takeUntil, switchMap, map} from 'rxjs/operators';
import {Component, OnInit, EventEmitter, Output, OnDestroy} from '@angular/core';
import {ConfigService} from '../../../services/ConfigService';
import {RequestService} from '../../../services/RequestService';
import {User} from '../../../services/api.client';
import {SecurityService} from '../../../services/SecurityService';

@Component({
    selector: 'navbar,[navbar]',
    templateUrl: './NavbarComponent.html',
    styleUrls: ['./NavbarComponent.scss'],
    standalone: false
})
export class NavbarComponent implements OnInit, OnDestroy {

  @Output('toggleSidebarEvent')
  toggleSidebarEvent: EventEmitter<any> = new EventEmitter();

  showLoader: boolean;
  sub: Subscription;

  currentUser: User;
  currentUser$: Observable<User>;
  currentAgency: any;

  constructor(
      public config: ConfigService,
      private securityService: SecurityService,
      private _request: RequestService) {
    this.currentUser$ = this.securityService.currentUser$;
  }

  logout(): void {
    this.securityService.logout();
  }

  toggleSidebar(state): void {
    this.toggleSidebarEvent.emit(state);
  }

  ngOnInit(): void {
    this.currentUser$.subscribe(user => this.currentUser = user);
    // TODO: make this a component
    const loading$ = this._request.loading;
    this.sub = loading$.pipe(
      switchMap((isLoading: boolean) => {
        if (isLoading) {
          return observableFrom([isLoading]);
        } else {
          return observableTimer(700).pipe(takeUntil(loading$), map(() => isLoading), );
        }
      }))
      .subscribe((isLoading) => this.showLoader = isLoading);
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

}
